module.exports = __webpack_public_path__ + "img/goals-building.a09ba9cc.png";